import { Color, DateInput, Input } from '@elearning-platform/ui';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { FormikContextType, useFormikContext } from 'formik';
import React, { FormEvent } from 'react';
import { TransProps, useTranslation } from 'react-i18next';

import { currentLanguage } from '../../../../../helpers/translations';
import { MissingProfileDataFieldType } from '../missingProfileData.enums';

import { Container, EmptyElement } from './dynamicFormField.styled';
import { DynamicFormFieldProps, MissingProfileFormValue, MissingProfileFormValues } from './dynamicFormField.types';

export const DynamicFormField: React.FC<DynamicFormFieldProps> = (props: DynamicFormFieldProps): JSX.Element => {
  const { t }: TransProps<never> = useTranslation();
  const { field, hasSubmitted }: DynamicFormFieldProps = props;
  const {
    values,
    setFieldValue,
    errors,
  }: FormikContextType<MissingProfileFormValues> = useFormikContext<MissingProfileFormValues>();

  const transformFormValueStringToDayjs: (value: MissingProfileFormValue) => dayjs.Dayjs | undefined = (
    value: MissingProfileFormValue
  ): dayjs.Dayjs | undefined => typeof value === 'string'
    ? /\d{4}-\d{2}-\d{2}/.test(value)
      ? dayjs(value.toString(), 'YYYY-MM-DD')
      : /\d{2}\.\d{2}\.\d{4}/.test(value)
        ? dayjs(value.toString(), 'DD.MM.YYYY')
        : undefined
    : undefined;

  return (
    <Container>
      {(
        [MissingProfileDataFieldType.Text, MissingProfileDataFieldType.Email].includes(field.fieldType)
      ) ? (
            <Input
              description={hasSubmitted ? errors[field.name] : ''}
              label={t(field.label)}
              onChange={(event: FormEvent<HTMLInputElement>): void => {
                void setFieldValue(field.name, (event.target as HTMLInputElement).value);
              }}
              value={values[field.name]?.toString() ?? ''}
              withError={!!errors[field.name] && hasSubmitted}
            />
          ) : field.fieldType === MissingProfileDataFieldType.Date ? (
            <LocalizationProvider adapterLocale={currentLanguage} dateAdapter={AdapterDayjs}>
              <DateInput
                brandColor={Color.Brand300}
                description={hasSubmitted ? errors[field.name] : ''}
                label={field.label}
                onChange={(value: dayjs.Dayjs | null): void => {
                  void setFieldValue(field.name, value?.format('YYYY-MM-DD'));
                }}
                value={transformFormValueStringToDayjs(values[field.name])}
                withError={!!errors[field.name] && hasSubmitted}
              />
            </LocalizationProvider>
          ) : <EmptyElement />}
    </Container>
  );
};
